/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_LoadingInputs */

const en_us2_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the workout`)
};

const pt_br2_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o treino`)
};

const es_419_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando el entrenamiento`)
};

const pt_pt2_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar o treino`)
};

const fr_fr2_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la séance`)
};

const de_de2_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training wird geladen`)
};

const it_it2_workout_quick_loading = /** @type {(inputs: Workout_Quick_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dell'allenamento`)
};

/**
* | output |
* | --- |
* | "Loading the workout" |
*
* @param {Workout_Quick_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_loading = /** @type {((inputs?: Workout_Quick_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_loading(inputs)
	if (locale === "es-419") return es_419_workout_quick_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_loading(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_loading(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_loading(inputs)
	return en_us2_workout_quick_loading(inputs)
});
export { workout_quick_loading as "workout-quick.loading" }